<div class="position-relative">
	<input #searchInput type="text" class="form-control coa-search-input" [class.is-invalid]="invalid()" [(ngModel)]="searchTerm"
		(input)="onInputChange()" (focus)="onFocus()" (blur)="onBlur()" (keydown)="onKeyDown($event)"
		[placeholder]="placeholder()" [disabled]="disabled()" autocomplete="off" />

	@if (searchTerm()) {
		<button
			class="btn btn-link position-absolute top-50 translate-middle-y end-0 border-0 bg-transparent coa-clear-button"
			type="button"
			(mousedown)="$event.preventDefault(); clearSearch()"
			(keydown.enter)="$event.preventDefault(); clearSearch()"
			(keydown.space)="$event.preventDefault(); clearSearch()"
			aria-label="Clear search">
			<fa-duotone-icon icon="xmark" class="text-secondary fs-6" secondaryOpacity="0.9" size="lg" />
		</button>
	}

	@if (showDropdown()) {
		<div class="dropdown-menu show coa-typeahead-dropdown">
			<!-- Category filter chips -->
			@if (chipCategories().length > 0) {
			<div class="coa-category-chips px-2 py-1 d-flex flex-wrap gap-1 border-bottom">
				<button type="button"
					class="btn btn-sm coa-chip"
					[class.active]="selectedCategory() === null"
					(mousedown)="$event.preventDefault(); selectCategory(null)">
					All
				</button>
				@for (category of chipCategories(); track category) {
					<button type="button"
						class="btn btn-sm coa-chip"
						[class.active]="selectedCategory() === category"
						(mousedown)="$event.preventDefault(); selectCategory(category)">
						{{ category | formatLabel }}
					</button>
				}
			</div>
			}

			<!-- Filtered account list -->
			<div class="coa-items-list">
				@if (isSearching()) {
					<div class="dropdown-item text-muted">Searching...</div>
				} @else if (filteredAccounts().length > 0) {
					@for (account of filteredAccounts(); track account.chartOfAccountId; let i = $index) {
						<button type="button"
							class="dropdown-item"
							[class.active]="i === selectedIndex()"
							[class.coa-selected]="isSelected(account)"
							[class.coa-unavailable]="isDisabledOption(account)"
							[disabled]="isUnselectable(account)"
							(mousedown)="!isUnselectable(account) && selectAccount(account)">
							<span class="coa-account-number me-2">{{ account.accountNumber }}</span>
							<span class="fw-medium">{{ account.name }}</span>
							@if (account.description) {
								<span class="coa-description ms-1">- {{ account.description }}</span>
							}
							@if (isDisabledOption(account) && disabledOptionNote()) {
								<span class="coa-unavailable-note ms-1">({{ disabledOptionNote() }})</span>
							}
						</button>
					}
					@if (hasMore()) {
						<div ms-in-view-port (inViewPort)="onLoadMore()" class="coa-scroll-sentinel"></div>
						@if (isLoadingMore()) {
							<div class="dropdown-item text-muted text-center">
								<span class="spinner-border spinner-border-sm" role="status"></span>
							</div>
						}
					}
				} @else {
					<div class="dropdown-item text-muted">No accounts found</div>
				}
			</div>
		</div>
	}
</div>
